module.exports = __webpack_public_path__ + "static/img/10.604655d.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/VascularSystem/Meeting824/images/10.png
// module id = 9pB2
// module chunks = 4